export class FormViewState {
  isCreating!: boolean | null
  isEditing!: boolean | null
  isViewingAmendment!: boolean | null
  isCreatingAmendment!: boolean | null
  isEditingAmendment!: boolean | null
  isLogView?: boolean;
}